<i18n>
    [
        "product__prepurchase--bullet1",
        "product__prepurchase--bullet2",
        "product__prepurchase--bullet3",
        "product__prepurchase--learnMoreCta",
        "product__prepurchase--exploreRentingCta",
    ]
</i18n>

<template>
    <div>
        <div class="o-flex-vertical-center u-spacer--2 o-text--caption u-text--gray">
            <AppIcon
                class="c-product-buy-details__image"
                icon="account--promo"
                size="24px"
                color="gray"
            />
            {{ firstBulletPointText }}
        </div>
        <div class="o-flex-vertical-center u-spacer--2 o-text--caption u-text--gray">
            <AppIcon
                :isCoreDir="false"
                class="c-product-buy-details__image"
                icon="box--in-transit"
                size="24px"
                color="gray"
            />
            {{ secondBulletPointText }}
        </div>
        <div class="o-flex-vertical-center u-spacer--3 o-text--caption u-text--gray">
            <AppIcon
                :isCoreDir="false"
                class="c-product-buy-details__image"
                icon="rewards--bonus-item"
                size="24px"
                color="gray"
            />
            {{ thirdBulletPointText }}
        </div>
        <div class="u-spacer--5 o-flex-vertical-center">
            <UrbnModalLauncher
                class="o-text--link"
                :modalOptions="MODALS.prePurchaseInfo"
                type="link"
            >
                <span class="o-text--caption">{{ learnMoreCTAText }}</span>
            </UrbnModalLauncher>
            <div
                class="c-product-buy-details__pipe"
            ></div>
            <div class="c-product-buy-details__explore-cta o-text--caption">
                <BaseLink
                    class="o-flex-vertical-center"
                    :to="productRentRoute"
                    @click="trackExploreRentingCTA"
                >
                    <div class="c-product-buy-details__link-text o-text--link">
                        {{ exploreRentingCTAText }}
                    </div>
                    <AppIcon
                        class="c-product-buy-details__link-arrow"
                        icon="global--right-arrow"
                        size="16px"
                        color="primary"
                    />
                </BaseLink>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useActions } from '~coreModules/core/js/composables/vuexHelpers';
import { useI18n } from 'vue-i18n';

import { GLOBAL_EVENT } from '~coreModules/core/js/store';

import { PRODUCT_CLICK } from '~coreModules/core/js/global-event-constants';
import { MODALS } from '~modules/modals/js/modal-constants';
import { rentalRouteNames } from '~modules/core/js/router-constants';
import { PRODUCT_BUSINESSES } from '~modules/analytics/js/analytics-constants';

import UrbnModalLauncher from '~coreModules/modals/components/UrbnModalLauncher.vue';

const props = defineProps({
    colorCode: {
        type: String,
        required: true,
    },
    productAnalyticsData: {
        type: Object,
        required: true,
    },
});

const { t } = useI18n();

const { trackGlobalEvent } = useActions({ trackGlobalEvent: GLOBAL_EVENT });

const firstBulletPointText = computed(() => t('product__prepurchase--bullet1'));
const secondBulletPointText = computed(() => t('product__prepurchase--bullet2'));
const thirdBulletPointText = computed(() => t('product__prepurchase--bullet3'));
const learnMoreCTAText = computed(() => t('product__prepurchase--learnMoreCta'));
const exploreRentingCTAText = computed(() => t('product__prepurchase--exploreRentingCta'));

const productRentRoute = computed(() => ({
    name: rentalRouteNames?.product,
    query: { color: props.colorCode },
}));

function trackExploreRentingCTA() {
    trackGlobalEvent({
        type: PRODUCT_CLICK,
        data: {
            ...props.productAnalyticsData,
            business: PRODUCT_BUSINESSES.RENT,
        },
    });
}

</script>

<style lang="scss">
.c-product-buy-details {
    $this: &;

    &__image {
        margin-right: $nu-spacer-1pt5;
    }

    &__pipe {
        @include pipe;
    }

    &__link-text {
        margin-right: $nu-spacer-1;
    }

    &__link-arrow {
        @media(hover: hover) and (pointer: fine) {
            #{$this}__explore-cta:hover & {
                margin-left: $nu-spacer-0pt5;
            }
        }
    }
}
</style>
